(function ($) {
    $.extend($.fn.dataTable.defaults.oLanguage, {
        "sProcessing": "Traitement en cours&hellip;",
        "sSearch": "Filtrer",
        "sLengthMenu": "Afficher _MENU_ éléments",
        "sInfo": "Éléments _START_ à _END_ sur _TOTAL_",
        "sInfoEmpty": "",
        "sInfoFiltered": "(filtré de _MAX_ éléments au total)",
        "sInfoPostFix": "&nbsp;",
        "sLoadingRecords": "Chargement en cours&hellip;",
        "sZeroRecords": "Aucun élément à afficher",
        "sEmptyTable": "Aucune donnée disponible dans le tableau",
        "oPaginate": {
            "sFirst": "Premier",
            "sPrevious": "Précédent",
            "sNext": "Suivant",
            "sLast": "Dernier"
        },
        "oAria": {
            "sSortAscending": ": activer pour trier la colonne par ordre croissant",
            "sSortDescending": ": activer pour trier la colonne par ordre décroissant"
        }
    });
})(jQuery);